import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { useEffect } from "react";

import { ConfigProvider } from "antd";

import { useTranslation } from "react-i18next";

import "./App.css";
import TABLE_THEME from "./components/data-table/tableTheme";
import PrivateRoute from "./routes/PrivateRoute";

import CheckPayment from "./features/payments/CheckPayment";
import ForgotPass from "./features/auth/ForgotPass";
import Login from "./features/auth/Login";
import SignUp from "./features/auth/SignUp";
import Body from "./components/body";
import "./config/i18_init";
import AuthenticatedBanners from "./components/Banner/AuthenticatedBanners";
import Cleaner from "./features/cleaner/components/Cleaner";
// import ChatWidget from "./features/reservations/components/subcompdash/ChatWidget";
import Billing from "./features/settings/components/billing/BillingGate";
import { CategoriesProvider } from "./contexts/CategoriesContext";
import OnboardingWizard from "./features/onboarding/components/OnboardingWizard";
import { ProductTourProvider } from "./components/product-tour/ProductTourProvider";

function App() {
    const { i18n } = useTranslation();

    // Initialize language from localStorage or browser preference
    useEffect(() => {
        const savedLanguage = localStorage.getItem("userLanguage");
        if (savedLanguage) {
            i18n.changeLanguage(savedLanguage);
        } else {
            // Use browser language if available and supported (en or es)
            const browserLang = navigator.language.split("-")[0];
            if (browserLang === "es" || browserLang === "en") {
                i18n.changeLanguage(browserLang);
                localStorage.setItem("userLanguage", browserLang);
            }
        }
    }, [i18n]);

    return (
        <>
            <CategoriesProvider>
                <ConfigProvider
                    theme={{
                        token: {
                            colorPrimary: "#5D5DF6",
                        },
                        components: {
                            Table: TABLE_THEME,
                        },
                    }}>
                    {/* <Offline><center>You're offline!</center></Offline> */}
                    <div className="min-h-screen bg-[#F2F2FA]">
                        <Router>
                            {/* <ChatWidget /> */}
                            <Switch>
                                {/* Public Routes — outside the provider */}
                                <Route exact path="/login" component={Login} />
                                <Route exact path="/signup" component={SignUp} />
                                <Route exact path="/forgotpassword" component={ForgotPass} />
                                <Route exact path="/pay" component={CheckPayment} />
                                <Route exact path="/statusUpdate" component={Cleaner} />

                                <Route>
                                    <ProductTourProvider>
                                        <AuthenticatedBanners />
                                        {/* A <Switch> is required here: without it, every one of these
                                            PrivateRoutes is a permanent sibling that independently checks
                                            the current location, so navigating from one matched route to
                                            another unmounts the old Body and mounts a brand new instance
                                            (resetting its local state, e.g. the sidebar's collapsed flag).
                                            Switch instead reuses the same matched slot across renders as
                                            long as the rendered component type stays the same. */}
                                        <Switch>
                                            {/* Onboarding Route */}
                                            <PrivateRoute exact path="/onboarding" component={OnboardingWizard} />

                                            {/* Dashboard Routes - All use Body component */}
                                            <PrivateRoute exact path="/" component={Body} />
                                            <PrivateRoute exact path="/reservations" component={Body} />
                                            <PrivateRoute exact path="/share-grow" component={Body} />
                                            <PrivateRoute exact path="/customers" component={Body} />
                                            <PrivateRoute exact path="/cars" component={Body} />
                                            <PrivateRoute exact path="/track" component={Body} />
                                            <PrivateRoute exact path="/user/:id" component={Body} />
                                            <PrivateRoute exact path="/cardetails/:id" component={Body} />
                                            <PrivateRoute exact path="/cars/add" component={Body} />
                                            <PrivateRoute exact path="/customers/:id" component={Body} />
                                            <PrivateRoute exact path="/customer-reservation" component={Body} />
                                            <PrivateRoute exact path="/make-reservation" component={Body} />
                                            <PrivateRoute exact path="/customer-reservation-vehicle" component={Body} />
                                            <PrivateRoute
                                                exact
                                                path="/reservations/:id/add-coverage"
                                                component={Body}
                                            />
                                            <PrivateRoute
                                                exact
                                                path="/reservations/:id/coverage-added"
                                                component={Body}
                                            />
                                            <PrivateRoute exact path="/reservations/:id/check-in" component={Body} />
                                            <PrivateRoute exact path="/reservations/:id/check-out" component={Body} />
                                            <PrivateRoute exact path="/reservations/:id" component={Body} />
                                            <PrivateRoute exact path="/track/reservation-tomorrow" component={Body} />
                                            <PrivateRoute exact path="/track/returning-today" component={Body} />
                                            <PrivateRoute exact path="/track/leaving-today" component={Body} />
                                            <PrivateRoute exact path="/customer-approval-requests" component={Body} />
                                            <PrivateRoute exact path="/ezpass" component={Body} />
                                            <PrivateRoute exact path="/cars/categories" component={Body} />
                                            <PrivateRoute exact path="/cars/locations" component={Body} />
                                            <PrivateRoute exact path="/add-ons" component={Body} />
                                            <PrivateRoute exact path="/add-ons/details/:id" component={Body} />
                                            <PrivateRoute exact path="/tolls" component={Body} />
                                            <PrivateRoute exact path="/cleaner-status" component={Body} />
                                            <PrivateRoute exact path="/cleaner-status/:id" component={Body} />
                                            <PrivateRoute exact path="/settings" component={Body} />
                                            <PrivateRoute exact path="/settings/employees/new" component={Body} />
                                            <PrivateRoute exact path="/settings/employees/:id" component={Body} />
                                            <PrivateRoute exact path="/settings/employees/:id/edit" component={Body} />
                                            <PrivateRoute exact path="/insurance" component={Body} />
                                            <PrivateRoute exact path="/sell-insurance" component={Body} />

                                            {/* Billing Route - Uses dedicated Billing component */}
                                            <PrivateRoute exact path="/subscription/billing" component={Billing} />
                                        </Switch>
                                    </ProductTourProvider>
                                </Route>
                            </Switch>
                        </Router>
                    </div>
                </ConfigProvider>
            </CategoriesProvider>
        </>
    );
}

export default App;
